<!--TeActivityTeacher:教师动态 2021/03/17 11:07:53 YuAng-->

<template>
  <div class="te-activity-teacher">
    <p class="its-part-title">
      <span>教师本月排行榜</span>
      <el-tooltip placement="right-start" :offset="-10">
        <div slot="content" style="line-height: 1.5">排名规则：<br />教学行为值 = 授课节数*50% + 预习任务数*30% + 校本上传份数*20%<br />只展示前5名<br />（今天的数据未计算在内哦~）</div>
        <span class="its-icon its-icon-question-circle"></span>
      </el-tooltip>
    </p>
    <te-rank ref="teRank"></te-rank>
    <p class="its-part-title">
      <span>教师动态</span>
    </p>
    <ul v-if="activtys && activtys.length > 0" class="its-te-activty">
      <li v-for="(item,index) in activtys" :key="'activty' + index">
        <p class="its-te-title" :title="item.title">
          <span class="span-point">· </span>
          <span style="color: black">{{item.userName}}</span>
          <span>{{item.content ? item.content.replace(item.userName,'').replace(item.title,'') : '--'}}</span>
          <span>“{{item.title}}”</span>
        </p>
        <p class="its-te-date">{{item.gmtModified | formatDate('M-d hh:mm')}}</p>
      </li>
    </ul>
    <div-no-data v-else>
      <p v-if="promise" class="empty">
        数据加载中...
      </p>
      <template v-else>
        <p class="empty">暂无动态</p>
        <p class="empty">
          快去
          <a style="color:#2695ff" :href="link.bk" target="_self">协同备课</a> 或
          <a style="color:#2695ff" :href="link.preclass" target="_self">布置预习</a>
          产生本校一条动态吧~
        </p>
      </template>
    </div-no-data>
  </div>

</template>
<script>
import { teacherHomeApi } from '@/utils/api'
import DivNoData from '../../../components/DivNoData.vue'
import TeRank from './TeRank.vue'
export default {
  components: { DivNoData, TeRank },
  name: 'TeActivityTeacher',
  props: {
    link: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data() {
    return {
      activtys: [],
      promise: null
    }
  },
  created() {
    this.promise = teacherHomeApi.getTeacherNews().then((resp) => {
      if (resp.success) {
        this.activtys = resp.body.items
      }
    })
    setTimeout(() => {
      this.promise = null
    }, 2 * 1000);
  }
}
</script>

<style scoped>
.its-te-activty {
  line-height: 28px;
  padding: 0 12px;
  margin: 0 8px;
}

.its-te-activty li {
  width: 100%;
  margin-bottom: 8px;
  overflow: hidden;
}

.its-te-title {
  float: left;
  width: calc(100% - 100px);
  padding: 0 10px;
  color: #757575;
  position: relative;
  line-height: 1.5;
}

.its-te-title .span-point {
  font-weight: bold;
  color: black;
  position: absolute;
  left: 1px;
  top: -1px;
}

.its-te-date {
  float: left;
  width: 100px;
  text-align: right;
  color: #757575;
}
</style>
